import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const isMicrosoftPersonalAccount = (
    state: IApplicationState,
): boolean => {
    const authUser = getAuthUser(state);
    return !Boolean(authUser.tenantName);
};
